import { z } from 'zod';
export const SOCIAL_PROVIDERS = ['google', 'microsoft', 'apple'];
export const socialProviderSchema = z.enum(SOCIAL_PROVIDERS);
export const socialStartResponseSchema = z.object({
    authorizationUrl: z.url(),
});
export const socialPendingReasonSchema = z.enum([
    'no_email',
    'email_unverified',
    'ambiguous_email',
    'email_untrusted',
]);
//# sourceMappingURL=social.js.map